import React from 'react';
import { useTranslation } from "react-i18next";

const ViewSectionAccordeon = ({ header }) => {
    const { t } = useTranslation();

    if (!header || !header.field || !header.module_text) return null;

    return (
        <div className="" style={{ fontWeight: "bold" }}> 
            {t(`${header.module_text}.large.${header.field}`)}
        </div>
    );
};

export default ViewSectionAccordeon;
